import styled from 'styled-components'
import { Box } from '../../../../shared_components/UI/Box'

export const Notice = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  max-width: 839px;
`

export const PlaceholderBox = styled.div`
  width: 241px;
  height: 210px;
  left: 1028px;
  top: 0px;
  border: 1px dashed
    ${({ theme }) =>
      theme.isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'};
  border-radius: 18px;
  margin-right: 10px;
  margin-bottom: 32px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

export const PlaceholderContainer = styled(Box)`
  margin-top: 32px;
  flex-wrap: wrap;
`
